import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AlertManagementService } from 'src/app/pages/alert-management/alert-management.service';
import { NotificationsComponent } from 'src/app/header/notifications/notifications.component';
import { DateInterval } from 'src/app/model/date-interval.model';
import { SigninService } from 'src/app/signin/signin.service';
import { Router } from '@angular/router';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';

@Component({
  selector: 'app-rt-bottom-nav',
  templateUrl: './rt-bottom-nav.component.html',
  styleUrls: ['./rt-bottom-nav.component.scss'],
})
export class RtBottomNavComponent implements OnInit, OnDestroy {
  @Input() historiqueActive = false;
  @Input() realtimeActive = false;
  @Output() centerMenuClick = new EventEmitter<void>();
  @Output() realtimeSelected = new EventEmitter<void>();

  notifications: any[] = [];
  dateInterval: DateInterval = new DateInterval();
  private destroy$ = new Subject<void>();
  private liveReloadingNotif: any;

  constructor(
    public signinService: SigninService,
    private alertManagementService: AlertManagementService,
    private modalCtrl: ModalController,
    private router: Router,
    private realTimeWorker: RealtimeWorkerService,
  ) {}

  ngOnInit(): void {
    this.initTimerNotif();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.liveReloadingNotif) {
      clearInterval(this.liveReloadingNotif);
    }
  }

  onRealtimeClick(historicalSubmenu: { hideFloatingSubmenu: (v: boolean) => void },
                  graphicalReportSubmenu: { hideFloatingSubmenu: (v: boolean) => void }): void {
    historicalSubmenu.hideFloatingSubmenu(true);
    graphicalReportSubmenu.hideFloatingSubmenu(true);
    this.realtimeSelected.emit();
    if (!this.realtimeActive) {
      this.router.navigate(['/client']);
    }
  }

  async clickNotifications(
    ev: Event,
    historicalSubmenu: { hideFloatingSubmenu: (v: boolean) => void },
    graphicalReportSubmenu: { hideFloatingSubmenu: (v: boolean) => void },
  ): Promise<void> {
    historicalSubmenu.hideFloatingSubmenu(true);
    graphicalReportSubmenu.hideFloatingSubmenu(true);
    this.realTimeWorker.prepareMapForOverlay();
    const dialog = await this.modalCtrl.create({
      component: NotificationsComponent,
      cssClass: 'notifDialog',
      showBackdrop: true,
      componentProps: { notifications: this.notifications },
    });
    await dialog.present();
    await dialog.onDidDismiss();
    this.realTimeWorker.restoreMapAfterOverlay();
  }

  private loadNotification(): void {
    this.alertManagementService
      .getNotifications(this.dateInterval)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (notifications) => {
          this.notifications = notifications;
        },
        error: (err) => console.error('Error loading notifications:', err),
      });
  }

  private initTimerNotif(): void {
    if (this.liveReloadingNotif) {
      clearInterval(this.liveReloadingNotif);
    }
    this.loadNotification();
    this.liveReloadingNotif = setInterval(() => this.loadNotification(), 20000);
  }
}
